<template>
  <div class="dropdown-select-contractor-button">
    <p
      v-if="title"
      class="title"
    >
      {{ title }}<span v-if="required">*</span>
    </p>
    <ValidationProvider
      v-slot="{ errors }"
      class="dropdown-wrap"
      :rules="rules"
    >
      <input
        type="hidden"
        :value="value"
      >
      <div
        v-click-outside="dropdownClose"
        class="dropdown-menu-button-wrap"
      >
        <div
          class="dropdown-menu-button"
          :class="{outline: outline,avatarButton:avatarButton,error:errors.length > 0,disabled:disabled}"
        >
          <i
            v-if="leadingIcon && !computedButtonAvatar"
            class="icon leading-icon"
            :class="[leadingIcon,{selected:value}]"
          />
          <button
            class="input-button"
            @click="onclick()"
          >
            <div
              v-if="avatarButton && computedButtonAvatar"
              class="avatar small"
              :style="{backgroundImage: 'url(' + computedButtonAvatar + ')' }"
              style="margin-right:6px"
            />
            <p
              v-if="avatarButton && computedButtonAvatar"
              class="select"
            >
              {{ computedButtonTextLabel }}
            </p>
            <p
              v-else
              :class="{selected:value}"
            >
              {{ computedButtonTextLabel }}
            </p>
          </button>
          <div v-if="!avatarButton">
            <i
              v-if="outline"
              class="icon trailing-icon outline icon-chevron-up"
              :class="{show: dropDownMenuShow}"
            />
            <i
              v-else-if="!outline && !dropDownMenuShow"
              class="icon trailing-icon icon-arrow-drop-down-circle"
            />
            <i
              v-else-if="!outline && dropDownMenuShow"
              class="icon trailing-icon icon-arrow-drop-up-circle"
            />
          </div>
        </div>
        <transition mode="out-in">
          <div
            v-if="dropDownMenuShow"
            class="dropdown-menu"
            :class="{priority:priority,avatarButton:avatarButton}"
          >
            <div class="search-tool">
              <SearchInput
                v-model="searchInputButton.value"
                :placeholder="searchInputButton.placeholder"
                :text-label="searchInputButton.textLabel"
                @enter="$_searchMemberByName()"
              />
            </div>
            <perfect-scrollbar class="ps dropdown-scrollable-content">
              <div
                v-for="(item,item_k) in _dropdownItems"
                :key="item_k"
                class="dropdown-menu-item"
                :class="{selected:selectedItem(item),textItem:textItem}"
                @click="selectMenuItem(item)"
              >
                <div
                  v-if="avatarSelect"
                  class="avatar"
                  :style="{backgroundImage:item.avatar ? 'url(' + item.avatar + ')' : 'url(' + require('@/assets/image/avatar.svg') + ')' }"
                />
                <p>{{ item.name }}</p>
              </div>
            </perfect-scrollbar>
            <div
              v-if="priority"
              class="add-btn"
              @click="addMemberOpen()"
            >
              <WsTextButton001
                leading-icon="icon-add-circle"
                primary
                narrow
              >
                {{ addTextLabel }}
              </WsTextButton001>
            </div>
          </div>
        </transition>
        <transition mode="out-in">
          <ValidationObserver
            v-if="addMemberActive"
            ref="memberObserver"
            class="dropdown-menu "
            :class="{show: addMemberActive}"
          >
            <div class="menu-title">
              <i
                class="icon-arrow-left"
                @click="addMemberClose()"
              />
              <p>{{ $t('新增承攬商') }}</p>
            </div>
            <div class="dropdown-content">
              <div class="input-item">
                <StateInputButton
                  v-model="addName"
                  :title="$t('名稱')"
                  :placeholder="$t('輸入')"
                  required
                  rules="required"
                />
              </div>
              <div class="input-item">
                <StateInputButton
                  v-model="addTax"
                  :title="$t('統一編號')"
                  :placeholder="$t('輸入')"
                  required
                  rules="required"
                />
              </div>
              <div class="input-item">
                <StateInputButton
                  v-model="addContent"
                  :title="$t('承攬業務')"
                  :placeholder="$t('請輸入承攬業務')"
                  required
                  rules="required"
                />
              </div>
              <div class="btns">
                <div class="btn">
                  <WsButton001
                    out-line
                    narrow
                    @click="addMemberClose()"
                  >
                    {{ $t('取消') }}
                  </WsButton001>
                </div>
                <div class="btn">
                  <WsButton001 @click="$_addContractorClick(_currentFactoryId)">
                    {{ $t('送出') }}
                  </WsButton001>
                </div>
              </div>
            </div>
          </ValidationObserver>
        </transition>
      </div>
      <div
        v-if="errors.length > 0"
        class="invalid-text"
      >
        <i class="icon-warning invalid-icon" />
        <p
          v-for="(text_e,text_k) in errors"
          :key="text_k"
          class="text"
        >
          {{ $t(text_e) }}
        </p>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "此項目為必填",
});
extend("email", {
  ...email,
  message: "email格式不符",
});

export default {
  name: "DropdownSelectContractorButton",
  directives: {
    ClickOutside,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    dropdownMenuItem: {
      type: Array,
      default() {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      type: Number,
      default: 0,
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    priority: {
      type: Boolean,
      default: false,
    },
    avatarButton: {
      type: Boolean,
      default: false,
    },
    addTextLabel: {
      type: String,
      default: "",
    },
    contractor: {
      type: Boolean,
      default: false,
    },
    avatarSelect: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: "",
    },
    textItem: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dropDownMenuShow: false,
    searchInputButton: {
      value: "",
      placeholder: this.$t("搜尋"),
      textLabel: this.$t("搜尋"),
    },
    addMemberActive: false,
    addTax: "",
    addName: "",
    addContent: "",
  }),
  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factoryId;
    },
    computedButtonTextLabel() {
      let selectedItem = this.value;
      let num = this.selectedItemNum(selectedItem);
      if (num > -1) {
        let selectedItemTextLabel = this.dropdownMenuItem[num];
        return selectedItemTextLabel.name;
      }
      let placeholder = this.placeholder;
      if (placeholder) return placeholder;
      return this.dropdownMenuItem[0].name;
    },
    computedButtonAvatar() {
      if (!this.avatarButton) {
        return;
      }
      let selectedItem = this.value;
      if (!selectedItem) {
        return;
      }
      let num = this.selectedItemNum(selectedItem);
      let selectedItemImg = this.dropdownMenuItem[num];
      return selectedItemImg.avatar;
    },
    _dropdownItems() {
      return this.$_searchMemberByName();
    },
  },
  methods: {
    onclick() {
      if (this.disabled) return;
      this.toggleDropdownMenuShow();
    },
    toggleDropdownMenuShow() {
      this.dropDownMenuShow = !this.dropDownMenuShow;
    },
    selectMenuItem(item) {
      this.$emit("input", item.id);
      this.dropDownMenuShow = false;
    },
    selectedItem(item) {
      if (this.value == item.id) {
        return true;
      } else {
        return false;
      }
    },
    selectedItemNum(select) {
      if (!this.dropdownMenuItem) return;
      if (!select) {
        return;
      }
      let allId = this.dropdownMenuItem.map((item) => {
        return item.id;
      });
      let selectedNum = allId.indexOf(select);
      return selectedNum;
    },
    dropdownClose() {
      this.dropDownMenuShow = false;
      this.addMemberActive = false;
      this.$_clearContractorData();
      this.searchInputButton.value = "";
    },
    addMemberOpen() {
      this.addMemberActive = true;
      this.dropDownMenuShow = false;
    },
    addMemberClose() {
      this.addMemberActive = false;
      this.$_clearContractorData();
      this.onclick();
    },
    $_clearContractorData() {
      this.addTax = "";
      this.addContent = "";
      this.addName = "";
    },
    $_searchMemberByName() {
      let originalItems = [...this.dropdownMenuItem];
      let searchOrigianlItems = originalItems.filter((item) => {
        return item.name
          .toLowerCase()
          .includes(this.searchInputButton.value.toLowerCase());
      });
      return searchOrigianlItems;
    },
    async $_addContractorClick(factoryId) {
      const isValidate = await this.$refs.memberObserver.validate();
      if (!isValidate) {
        return;
      }
      try {
        const res = await this.$axios.post(`/factory/${factoryId}/contractor`, {
          uniform_number: this.addTax,
          name: this.addName,
          task_description: this.addContent,
        });
        let contractorId = res.data.data.id;
        let contractorName = res.data.data.name;
        let contractorData = {
          id: contractorId,
          name: contractorName,
        };
        this.$emit("input", contractorId);
        this.$emit("add-contractor", contractorData);
        this.dropdownClose();
      } catch (err) {
        alert(this.$t("新增承攬商失敗"));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/dropdown-select-contractor-button";
</style>